import { client } from "@lib/api"
import useSWR from "swr"

type RedemptionLimit = {
    redeem_to_crypto_remaining: string,
    redeem_request_remaining: string,
    total_redeem_request_limit: string,
    maximum_split_disbursements: number
}

const useRedemptionLimit = () => {
    const { data, error, isLoading } = useSWR('/wallet/my-limit', client.doGet)
    return {
        data: data as RedemptionLimit,
        isLoading,
        error
    }
}

export default useRedemptionLimit
